import { render, staticRenderFns } from "./NewTeam.vue?vue&type=template&id=5c602fff&scoped=true&"
import script from "./NewTeam.vue?vue&type=script&lang=js&"
export * from "./NewTeam.vue?vue&type=script&lang=js&"
import style0 from "./NewTeam.vue?vue&type=style&index=0&id=5c602fff&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c602fff",
  null
  
)

export default component.exports